export enum PropertyBuildingMarketSegmentEnum {
  corporate= 'corporate',
  military = 'military',
  senior = 'senior',
  vacation = 'vacation',
}

export const PropertyBuildingMarketSegmentLabels = {
  [PropertyBuildingMarketSegmentEnum.corporate]: 'Corporate',
  [PropertyBuildingMarketSegmentEnum.military]: 'Military',
  [PropertyBuildingMarketSegmentEnum.senior]: 'Senior',
  [PropertyBuildingMarketSegmentEnum.vacation]: 'Vacation',
}
